/**
 * SEO対応のヘルパー関数
 */

// サイト基本情報
const SITE_INFO = {
  title: 'デリヘル専用SNS「DNS」 - 女の子との新しいコミュニケーションツール（風俗ポータル）',
  description: 'デリヘル（風俗）専用SNS「DNS」（デリヘル・ネットワーク・サービス）では、働く女の子たちの投稿をチェックし、コメントやいいね、メッセージで気軽に交流できます。新しい出会いを楽しみましょう！当サイトは風俗店が掲載されています。18歳未満のご利用はご遠慮ください。',
  siteName: 'デリヘル専用SNS「DNS」',
  twitterSite: '@deli_ns',
  ogImage: '/images/og-default.jpg'
};

/**
 * ページタイトルを設定する
 * @param {string} title - ページタイトル
 * @param {boolean} includeBase - ベースタイトルを含むかどうか
 */
export const setPageTitle = (title, includeBase = true) => {
  if (includeBase) {
    document.title = `${title} | ${SITE_INFO.title}`;
  } else {
    document.title = title;
  }
};

/**
 * メタタグを設定する
 * @param {Object} meta - メタタグ情報
 */
export const setMetaTags = (meta = {}) => {
  const {
    title = SITE_INFO.title,
    description = SITE_INFO.description,
    keywords = '',
    image = SITE_INFO.ogImage,
    url = window.location.href,
    type = 'website'
  } = meta;

  // 既存のメタタグを削除
  removeMetaTags();

  // 基本メタタグ
  setMetaTag('description', description);
  if (keywords) setMetaTag('keywords', keywords);

  // Open Graph
  setMetaTag('og:title', title, 'property');
  setMetaTag('og:description', description, 'property');
  setMetaTag('og:image', image, 'property');
  setMetaTag('og:url', url, 'property');
  setMetaTag('og:type', type, 'property');
  setMetaTag('og:site_name', SITE_INFO.siteName, 'property');

  // Twitter Card
  setMetaTag('twitter:card', 'summary_large_image', 'name');
  setMetaTag('twitter:site', SITE_INFO.twitterSite, 'name');
  setMetaTag('twitter:title', title, 'name');
  setMetaTag('twitter:description', description, 'name');
  setMetaTag('twitter:image', image, 'name');

  // その他のSEO用タグ
  setMetaTag('robots', 'index,follow', 'name');
  setMetaTag('canonical', url, 'rel', 'link');
};

/**
 * メタタグを設定する内部関数
 */
const setMetaTag = (name, content, attribute = 'name', tagName = 'meta') => {
  if (!content) return;

  let element = document.querySelector(`${tagName}[${attribute}="${name}"]`);
  
  if (tagName === 'link') {
    if (!element) {
      element = document.createElement('link');
      element.setAttribute(attribute, name);
      document.head.appendChild(element);
    }
    element.setAttribute('href', content);
  } else {
    if (!element) {
      element = document.createElement(tagName);
      element.setAttribute(attribute, name);
      document.head.appendChild(element);
    }
    element.setAttribute('content', content);
  }
};

/**
 * 既存のメタタグを削除
 */
const removeMetaTags = () => {
  const metaSelectors = [
    'meta[name="description"]',
    'meta[name="keywords"]',
    'meta[property^="og:"]',
    'meta[name^="twitter:"]',
    'meta[name="robots"]',
    'link[rel="canonical"]'
  ];

  metaSelectors.forEach(selector => {
    const elements = document.querySelectorAll(selector);
    elements.forEach(element => {
      if (!element.hasAttribute('data-keep')) {
        element.remove();
      }
    });
  });
};

/**
 * 投稿詳細ページのタイトルを生成
 * @param {Object} post - 投稿データ
 * @returns {string} - ページタイトル
 */
export const generatePostTitle = (post) => {
  if (!post) return SITE_INFO.title;

  const authorName = post.author?.display_name || post.author?.username || 'ユーザー';
  const text = post.text || '';
  
  // 本文の最初の5文字を取得
  const textPreview = text.replace(/\n/g, ' ').substring(0, 5);
  
  // ハッシュタグを抽出
  const hashtags = (text.match(/#[\w\u3042-\u3096\u30A1-\u30FA\u4E00-\u9FAF]+/g) || []).slice(0, 3).join(' ');
  
  // 日付と時間をフォーマット
  const createdAt = new Date(post.created_at);
  const date = createdAt.toLocaleDateString('ja-JP', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric'
  });
  const time = createdAt.toLocaleTimeString('ja-JP', {
    hour: '2-digit',
    minute: '2-digit'
  });

  // タイトルを組み立て
  let title = `${authorName}`;
  if (textPreview) title += ` | ${textPreview}`;
  if (hashtags) title += ` ${hashtags}`;
  title += ` | ${date} ${time}`;

  return title;
};

/**
 * プロフィールページのタイトルを生成
 * @param {Object} profile - プロフィールデータ
 * @returns {string} - ページタイトル
 */
export const generateProfileTitle = (profile) => {
  if (!profile) return SITE_INFO.title;

  const displayName = profile.display_name || profile.username || 'ユーザー';
  return `プロフィール ${displayName}`;
};

/**
 * 投稿詳細ページのメタデータを生成
 * @param {Object} post - 投稿データ
 * @returns {Object} - メタデータ
 */
export const generatePostMeta = (post) => {
  if (!post) return {};

  const authorName = post.author?.display_name || post.author?.username || 'ユーザー';
  const text = post.text || '';
  const textPreview = text.replace(/\n/g, ' ').substring(0, 160);
  
  const description = textPreview || `${authorName}さんの投稿をチェック！`;
  const image = post.image || post.author?.avatar || SITE_INFO.ogImage;
  
  return {
    title: generatePostTitle(post),
    description,
    image,
    type: 'article',
    keywords: `${authorName}, 投稿, デリヘル, コミュニティ`
  };
};

/**
 * プロフィールページのメタデータを生成
 * @param {Object} profile - プロフィールデータ
 * @returns {Object} - メタデータ
 */
export const generateProfileMeta = (profile) => {
  if (!profile) return {};

  const displayName = profile.display_name || profile.username || 'ユーザー';
  const bio = profile.bio || '';
  
  const description = bio 
    ? `${displayName}さんのプロフィール: ${bio.substring(0, 120)}` 
    : `${displayName}さんのプロフィールをチェック！フォローして最新の投稿をチェックしよう。`;
  
  const image = profile.avatar || SITE_INFO.ogImage;
  
  return {
    title: generateProfileTitle(profile),
    description,
    image,
    type: 'profile',
    keywords: `${displayName}, プロフィール, ユーザー, デリヘル, コミュニティ`
  };
};

export default {
  setPageTitle,
  setMetaTags,
  generatePostTitle,
  generateProfileTitle,
  generatePostMeta,
  generateProfileMeta,
  SITE_INFO
}; 